document.querySelectorAll('.customSelectBox').forEach(function (item, index) {
    let customSelectBox = item;
    let clickedOpt = customSelectBox.querySelector('.clickedOpt');

    let selectedItem = customSelectBox.querySelector('.customOptList.selected');
    let selectedOpt = selectedItem ? selectedItem.getAttribute('data-val') : '';
    let selectedOpt2 = selectedItem ? selectedItem.getAttribute('data-val2') : '';

    clickedOpt.innerHTML = `<div class="selectedOpt">${selectedOpt} <span>${selectedOpt2}</span></div>
    <i class="icon-arrow"></i>`;

    // clickedOpt 클릭
    customSelectBox.addEventListener('click', function (e) {
        if (e.target.closest('.clickedOpt')) {
        clickedOpt.classList.toggle('active');
        let ul = customSelectBox.querySelector('ul');
        if (ul) {
            ul.style.display = ul.style.display === 'none' || ul.style.display === '' ? 'block' : 'none';
        }
        }
    });

    // mouseleave
    customSelectBox.addEventListener('mouseleave', function () {
        clickedOpt.classList.remove('active');
        let ul = customSelectBox.querySelector('ul');
        if (ul) {
        ul.style.display = 'none';
        }
    });

    // 옵션 1개 이하일 때
    if (customSelectBox.querySelectorAll('.customOptList').length < 2) {
        customSelectBox.classList.add('noSub');
    }
});